
@if (numberOfDaysLeft) {
  <div class="sidebar-trial">
    <h1 class="sidebar-trial__title">
      <i class="fa-solid fa-hourglass-half" aria-hidden="true"></i>
      {{'sidebar.trial.title'|transloco}}
    </h1>
    <p class="sidebar-trial__content">{{'sidebar.trial.content'|transloco: {'days': numberOfDaysLeft} }}</p>
    <app-progress-bar
      [progress]="progress()"
      [contrast]="true"
    ></app-progress-bar>

    <button class="button button--white button--full-width"
            (click)="redirectToCustomerPortal()"
    >
      <i class="fa-solid fa-credit-card"></i>
      {{'sidebar.trial.button'|transloco}}
    </button>
  </div>
}
